import { observable } from "mobx";

import { MedicalDataCategory, SupportedMedicalData } from "../../../api";
import { ApiConnector } from "../../../api/api-connector";
import { fetchSupportedMedicalData } from "../../../catalogs/supported-medical-data";
import { DataAdd } from "../../../models/data-add";
import { getServerNowISO } from "../../../utils/server-time";
import { Patient } from "../patient";

export class AddRHC extends DataAdd {
  @observable accessor supportedVariables: SupportedMedicalData[] = [];

  constructor(api: ApiConnector, patient: Patient) {
    super(api, patient);
    this.initFields = [
      "measurement_datetime",
      "measurement_type",
      "measurement_unit",
    ];
    this.desc = "Right Heart Catheterization exams";
    this.defaultDateTimeName = "Now";
    this.defaultDateTimeFields = ["measurement_datetime"];

    // constants
    this.required = [
      "RHC right atrial pressure mean",
      "RHC pulmonary capillary wedge pressure",
      "RHC pulmonary artery pressure mean",
      "RHC mixed venous oxygen saturation",
      "RHC systemic blood pressure systolic",
      "RHC systemic blood pressure diastolic",
    ];
    this.requiredEitherOr = [
      "RHC stroke volume - Fick",
      "RHC stroke volume - TD",
      "RHC cardiac output - Fick",
      "RHC cardiac output - TD",
    ];
    this.bodyField = "medical_data";
    this.endpoint = "hf/exams/rhc";
    this.reloadToTab = "exams";
  }

  async initEmpty() {
    this.defaultDateTime = getServerNowISO();
    const supportedMedData = await fetchSupportedMedicalData();
    this.supportedVariables = supportedMedData.filter(
      (data) => data.data_category === MedicalDataCategory.exams_rhc,
    );
    const empty = [];
    for (const variable of this.supportedVariables) {
      const temp = {
        measurement_datetime: this.defaultDateTime,
        measurement_type: variable.data_name,
        measurement_unit: variable.primary_unit,
      };
      empty.push(temp);
    }
    this.addingList = empty;
  }
}
